import { oneOf } from 'prop-types'

export default oneOf([
  'startLines',
  'startRight',
  'startRightDark',
  'startLeft',
  'startLeftDark',
  'endRight',
  'endLeft',
  'bottomTopLeft',
  'bottomTopLeftDark',
  'bottomTopRight',
  'bottomTopRightDark',
  'straightLeft',
  'straightLeftDark',
  'straightRight',
  'straightRightDark',
])
